module.exports = __webpack_public_path__ + "89e2666c24d37055bcb60e9d2d9f7e35.ttf";